<template>
  <div>
    <link itemprop="url" rel="stylesheet" href="css/programs.css"/>
    <b-container>
      <b-row>
        <b-col sm="3">
          <Filters/>
        </b-col>
        <b-col sm="9">
          <b-row>
            <b-col sm="4" cols="6" v-for="f in 6" :key="f">
              <ShoppingCard/>
            </b-col>
          </b-row>
          <b-row>
            <div class="see-more">
               <b-button variant="primary" @click="LoadingNumber = 4">المزيد</b-button>
            </div>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script type="text/javascript">
  import Filters       from '../global/Filters'
  import ShoppingCard from '../global/ShoppingCard'
  export default {
    name:'Shopping',
    components: {
      Filters,
      ShoppingCard
    }
  }
</script>
